import styled from 'styled-components';

export const LayoutMainComponent = styled.main`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: calc(100% - 3rem);
`;
